import { memo } from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import ThinkingAnimation from "components/ThinkingAnimation";

const StandardLoadingIndicator = memo(function StandardLoadingIndicator({
  size = 40,
  color = "info",
  containerHeight = null,
  inline = false,
}) {
  if (inline) {
    return <CircularProgress size={size} color={color} />;
  }

  return (
    <ThinkingAnimation
      size={size > 50 ? "md" : "sm"}
      containerHeight={containerHeight}
    />
  );
});

StandardLoadingIndicator.propTypes = {
  size: PropTypes.number,
  color: PropTypes.oneOf(["primary", "secondary", "inherit", "info", "success", "warning", "error"]),
  containerHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inline: PropTypes.bool,
};

export default StandardLoadingIndicator;
